import { h, Component } from 'preact';
import util from 'preact-util';
import { Text } from 'preact-i18n';

/*
 * Super-admin per-user "log out on all devices" button for the clinic member table.
 * First click arms it (Log out? / Cancel), second click posts /api/sessions/admin/revoke-user.
 */
class ForceLogoutUserButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            armed: false,
            submitting: false,
            done: null,
        };
    }

    stop = (e) => {
        if (e && e.preventDefault) {
            e.preventDefault();
            e.stopPropagation();
        }
    }

    arm = (e) => {
        this.stop(e);
        this.setState({ armed: true });
    }

    disarm = (e) => {
        this.stop(e);
        this.setState({ armed: false });
    }

    submit = async (e) => {
        this.stop(e);
        const { stores, user = {}, onDone } = this.props;
        const { appState } = stores;
        this.setState({ submitting: true });
        const response = await util.fetchApi('/api/sessions/admin/revoke-user', { method: 'POST' }, {
            userId: user.id,
            confirmed: true,
        });
        if (response && response.status === 200) {
            const { sessionsRevoked = 0 } = response.data || {};
            const name = `${user.firstname || ''} ${user.lastname || ''}`.trim();
            appState.addToast({ type: 'success', message: `${name} er logget ut på alle enheter (${sessionsRevoked} sesjoner).` }, 5000);
            this.setState({ submitting: false, armed: false, done: { sessionsRevoked } });
            if (onDone) {
                onDone({ user, sessionsRevoked });
            }
        } else {
            const message = (response && response.message) || 'Kunne ikke logge ut brukeren.';
            appState.addToast({ type: 'error', message, icon: 'triangle-exclamation' }, 8000);
            this.setState({ submitting: false, armed: false });
        }
    }

    render() {
        const { armed, submitting, done } = this.state;

        if (done) {
            return (
                <small class='text-success text-nowrap'>
                    <i class='fa-solid fa-check me-1' />
                    <Text id='admin.forceLogout.userDone' fields={{ sessions: done.sessionsRevoked }}>Logged out ({done.sessionsRevoked})</Text>
                </small>
            );
        }

        if (armed) {
            return (
                <span class='d-inline-flex flex-row gap-1'>
                    <button type='button' class='btn btn-sm btn-danger rounded-pill text-nowrap' disabled={submitting} onClick={this.submit}>
                        {submitting ? <i class='fa-solid fa-spinner fa-spin me-1' /> : <i class='fa-solid fa-right-from-bracket me-1' />}
                        <Text id='admin.forceLogout.userConfirm'>Log out?</Text>
                    </button>
                    <button type='button' class='btn btn-sm btn-outline-secondary rounded-pill' disabled={submitting} onClick={this.disarm}>
                        <Text id='admin.forceLogout.cancel'>Cancel</Text>
                    </button>
                </span>
            );
        }

        return (
            <button
                type='button'
                class='btn btn-sm btn-outline-danger rounded-pill'
                title='Logg ut brukeren på alle enheter'
                onClick={this.arm}
            >
                <i class='fa-solid fa-right-from-bracket' />
            </button>
        );
    }
}

export default ForceLogoutUserButton;
